import Button from '@ixigo/iui/Button';
import Typography from '@ixigo/iui/Typography';
import useNavigateWithTransition from '../../hooks/useNavigateWithTransition';
import brokenScreen from '../../images/brokenScreen.svg';

interface FullScreenErrorProps {
    title?: string;
    description?: string;
    showBackButton?: boolean;
}

const defaultTitle = 'Aaaah! Something went wrong';
const defaultDescription = 'Sorry! We cannot process your request at the moment. Please try again later.';

function FullScreenError({
    title = defaultTitle,
    description = defaultDescription,
    showBackButton = true,
}: FullScreenErrorProps) {
    const navigate = useNavigateWithTransition();

    return (
        <div className='flex flex-col justify-center items-center h-full'>
            <img className='max-w-screen-sm' src={brokenScreen} alt='Something went wrong' draggable={false} />
            <div className='flex flex-col items-center gap-20 p-20'>
                <div className='flex flex-col justify-center gap-10'>
                    <Typography variant='h6' fontWeight='medium' className='text-center'>
                        {title}
                    </Typography>
                    <Typography variant='body-sm' className='text-center'>
                        {description}
                    </Typography>
                </div>
                {showBackButton && (
                    <Button size='lg' variant='flat' onClick={() => navigate(-1, { type: 'backward' })}>
                        Go Back
                    </Button>
                )}
            </div>
        </div>
    );
}

export default FullScreenError;
